// extracted by mini-css-extract-plugin
export default {"homeButton":"CastleTowerRoom_homeButton__Uhb4m","mapButton":"CastleTowerRoom_mapButton__ianMv","button":"CastleTowerRoom_button__vnuZ3"};